import {AfterContentInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MemberModel} from '../../../models/user.model';
import {DepartmentControlService} from '../../../services/departments/department-control.service';
import {ActivatedRoute} from '@angular/router';
import {HelpersService} from '../../../services/helpers.service';
import {DepartmentModel, DepartmentUserModel, DivisionModel} from '../../../models/department.model';
import {MemberService} from '../../../services/member.service';
import {DepartmentsService} from '../../../services/api/departments.service';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-departments-control-detail',
    templateUrl: './departments-control-detail.component.html',
    styleUrls: ['./departments-control-detail.component.scss'],
})
export class DepartmentsControlDetailComponent implements OnInit, AfterContentInit {
    @ViewChild('inviteMemberView') public inviteMemberView: TemplateRef<any>;
    public usersInProject: MemberModel[] = [];
    public tab = 'divisions';
    public departmentUsers: DepartmentUserModel[] = [];
    public loading = false;
    public departmentDetails: DepartmentModel;
    currentMember: MemberModel;
    canEdit = false;
    currentDepAdmin: DepartmentUserModel;
    isLockButton = false;
    isLockGroupButton = [];
    divisionSlider: {
        [key: number]: boolean
    } = {};
    departmentDivisions: DivisionModel[] = [];
    divisionId: number | null = null;
    divisionsMembers: {
        [key: string]: MemberModel
    } = {};
    protected departmentId: number;

    constructor(
        protected departmentApi: DepartmentsService,
        protected alertService: AlertService,
        public memberService: MemberService,
        private departmentControl: DepartmentControlService,
        private activatedRoute: ActivatedRoute,
        public helper: HelpersService,
        public modalService: ModalService,
        public translate: TranslateService,
    ) {
        this.departmentId = this.activatedRoute.snapshot.params.department_id;

        void this.getDepartmentUsers();
    }

    ngAfterContentInit(): void {
        this.memberService.getAllMembers().then(membersAll => {
            this.usersInProject = membersAll.filter(x => !x.project_setting.is_project_admin && x.project_setting.observation_type !== 'blocked');
        });
        this.memberService.getCurrentMember().then(res => {
            this.currentMember = res;
        });
    }

    ngOnInit(): void {
        this.getDivisions();
    }

    getDivisions(): void {
        this.departmentControl.getDivisions(this.departmentId).then(res => {
            this.departmentDetails = res.department;
            this.departmentDivisions = res.divisions;
            this.divisionsMembers = res.members;
        });
    }

    onAddMember(): void {
        for (const element of this.departmentUsers) {
            this.usersInProject = this.usersInProject.filter(x => x.guid !== element.member.guid);
        }
        this.modalService.openTemplateModal(this.inviteMemberView);
    }

    async removeUserFromDepartment(user: DepartmentUserModel): Promise<any> {
        this.isLockGroupButton[this.departmentUsers.indexOf(user)] = true;
        const result = await this.departmentControl.deleteUserFromDepartment(this.departmentId, user);
        if (result) {
            this.isLockGroupButton[this.departmentUsers.indexOf(user)] = false;
            await this.departmentControl.getDepartmentUsers(this.departmentId).then(users => {
                this.departmentUsers = users as DepartmentUserModel[];
                this.usersInProject.unshift(user.member);
            }).catch(() => {
                this.departmentUsers = [];
                this.usersInProject.unshift(user.member);
            });
        } else {
            this.isLockGroupButton[this.departmentUsers.indexOf(user)] = false;
        }
    }

    sendInviteToDepartment(rights: string, userMail: string, modal: NgbModalRef): void {
        if (!rights) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.SET_PERMISSION'), 'blue');
        }
        const data = {
            id: this.departmentId,
            email: userMail,
            observ: rights,
        };
        this.isLockButton = true;
        this.departmentApi.inviteUserToDepartment(data).subscribe({
            next: () => {
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS_ADD_MEMBER'), 'green');
                void this.getDepartmentUsers();
                modal.close();
                this.isLockButton = false;
            }, error: error => {
                this.isLockButton = false;
                this.alertService.setAlert(error.message, 'blue');
            },
        });
    }

    async getDepartmentUsers(): Promise<any> {
        this.loading = true;
        this.departmentControl.getDepartmentUsers(this.departmentId).then(result => {
            this.loading = false;
            this.departmentUsers = result as [];
            this.currentDepAdmin = this.departmentUsers.filter(x => x.member.guid === this.currentMember.guid)[0];
            this.canEdit = !!this.currentDepAdmin;
        }).catch(() => {
            // void this.router.navigate(['account', 'options', 'departments']);
        });
    }

    onEditDepartment(name: string): void {
        if (!name) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.SET_DEP_NAME'), 'blue');
        }
        this.departmentApi.updateDepartment(this.departmentDetails.id, name).subscribe({
            next: res => {
                this.alertService.setAlert(res.message, 'green');
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
            },
        });
    }

    setDepartmentAdmin(user: {
        member: MemberModel;
        is_department_admin: boolean;
    }): void {
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.ATTENTION'),
            modalBody: this.translate.instant('CONFIRM.TEXT.CHANGE_ROLE', {name: this.helper.fullName(user.member)}),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(ans => {
            if (ans) {
                const data = {
                    id: this.departmentDetails.id,
                    guid: user.member.guid,
                    is_admin: !user.is_department_admin,
                };
                this.departmentApi.setUsersRightsInDepartment(data).subscribe({
                    next: res => {
                        this.alertService.setAlert(res.message, 'green');
                        void this.getDepartmentUsers();
                    }, error: error => {
                        this.alertService.setAlert(error.message, 'blue');
                    },
                });
            }
        }).catch(() => {
            return;
        });
    }

    setDivisionIdAndOpenModal(content: TemplateRef<any>, id: number | null = null): void {
        this.divisionId = id;
        this.modalService.openTemplateModal(content);
    }

    createDivision(divisionName: string, modal: NgbModalRef): void {
        const data = {
            department_id: this.departmentId,
            name: divisionName,
            parent_id: this.divisionId,
        };
        this.departmentApi.createDivision(data).subscribe({
            next: res => {
                this.alertService.setAlert(res.message, 'green');
                this.getDivisions();
                modal.close();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    addMemberToDivision(memberEmail: string, modal: NgbModalRef): void {
        const data = {
            department_id: this.departmentId,
            division_id: this.divisionId,
            email: memberEmail,
        };
        this.departmentApi.addMemberToDivision(data).subscribe({
            next: res => {
                modal.close();
                this.getDivisions();
                void this.getDepartmentUsers();
                this.alertService.setAlert(res.message, 'green');
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    editDivision(name: string, modal: NgbModalRef): void {
        this.departmentApi.editDivision(this.divisionId, name).subscribe({
            next: res => {
                modal.close();
                this.alertService.setAlert(res.message, 'green');
                this.getDivisions();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    deleteDivision(division: any): void {
        const modalSettings: any = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_DIVISION', {name: division.name}),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.departmentApi.deleteDivision(division.id).subscribe({
                    next: res => {
                        this.alertService.setAlert(res.message, 'green');
                        void this.getDivisions();
                        void this.getDepartmentUsers();
                    },
                    error: error => {
                        this.alertService.setAlert(error.message, 'blue');
                    },
                });
            }
        }).catch(() => {
            return;
        });
    }

    deleteMemberFromDivision(memberGuid: string, division: any): void {
        const modalSettings: any = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_MEMBER_DIV', {
                name: this.helper.shortFullName(this.divisionsMembers[memberGuid]),
                division: division.name
            }),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.departmentApi.deleteMemberFromDivision(division.id, memberGuid).subscribe({
                    next: res => {
                        this.alertService.setAlert(res.message, 'green');
                        void this.getDivisions();
                        void this.getDepartmentUsers();
                    },
                    error: error => {
                        this.alertService.setAlert(error.message, 'blue');
                    },
                });
            }
        }).catch(() => {
            return;
        });
    }
}
